module.exports = __webpack_public_path__ + "img/blade4.51d00653.png";